module.exports = __webpack_public_path__ + "static/img/网站-网站开发.9c6c01e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10007/网站-网站开发.png
// module id = PwGb
// module chunks = 1